<template>
  <v-dialog
    v-model="isDialog"
    max-width="500"
    persistent
    light
  >
    <v-card v-if="isDialog">
      <div class="">
        <!--            <div class="absX" @click.passive="closeDialog">X</div>-->
        <div class="pb-2"></div>

        <v-card-title v-if="$store.getters.deviceClass.includes('xs')" class="headline text-center darkColor d-block">
          Datenschutz-einstellungen
        </v-card-title>

        <v-card-title v-else class="headline text-center d-block darkColor">Datenschutzeinstellungen</v-card-title>

        <v-card-text>
          <div class="text-center dsgvo">
            <p class="text-left">Wir verwenden Cookies, um Dir ein schnelles und personalisiertes
              Erlebnis zu bieten.
              Details zu den verwendeten Cookies und unseren Partnern findest Du
              <router-link :to="{ name: 'Cookies' }" @click.native="closeDialog">hier</router-link>
              .
            </p>

            <v-row class="bigger-input align-center justify-space-between">
              <v-col>
                <v-checkbox
                  :disabled="true"
                  class="d-inline-block "
                  v-model="notwendig"
                  label="Notwendig"
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  class="d-inline-block"
                  v-model="statistics"
                  label="Statistiken"
                ></v-checkbox>
              </v-col>
              <!--                            <v-col>-->
              <!--                                <v-checkbox-->
              <!--                                        class="d-inline-block"-->
              <!--                                        v-model="facebook"-->
              <!--                                        label="Facebook"-->
              <!--                                ></v-checkbox>-->
              <!--                            </v-col>-->
              <!--                        <v-col>-->
              <!--                            <v-checkbox-->
              <!--                                    class="d-inline-block"-->
              <!--                                    v-model="analytics"-->
              <!--                                    label="Benachrichtung"-->
              <!--                            ></v-checkbox>-->
              <!--                        </v-col>-->
            </v-row>


            <div class="pa-1">
              <!--                        <div>-->
              <v-btn class="okBtn btn-df text-none" rounded @click.native.passive.stop="clickOk">
                Einverstanden
              </v-btn>
              <!--                        </div>-->
              <!--                        <div>-->
              <!--                            <v-btn class="grayBtn btn-df text-none" rounded @click.native.passive.stop="clickOk">-->
              <!--                                Auswahl speichern-->
              <!--                            </v-btn>-->
              <!--                        </div>-->
            </div>

            <div class="spacer-25"></div>


            <div class="pt-2">Deine Einwilligung ist jederzeit widerrufbar.</div>

            <!--                    <div>Invidiuelle Datenschutzeinstellungen</div>-->
            <div>
              <router-link :to="{ name: 'Cookies' }" @click.native="closeDialog">Cookie-Details
              </router-link>
              |
              <router-link :to="{ name: 'Datenschutz' }" @click.native="closeDialog">Datenschutzerklärung
              </router-link>
            </div>
          </div>
        </v-card-text>

        <div class="pb-2"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {ebus} from '../vendor/ebus';
import * as util from '../vendor/util'

export default {
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      isDialog: false,

      notwendig: true,//always true

      statistics: true,
      facebook: true,
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        //init
        this.init();
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('close');
      }
    }
  },

  methods: {
    init() {
      // this.statistics = true;

      let dsgvo = this.$ls.get('dsgvo', {});
      if (util.isEmptyObject(dsgvo)) {
        //default
        this.statistics = true;
        // this.facebook = true;
      } else {
        this.statistics = !!dsgvo.statistics;
        // this.facebook = !!dsgvo.facebook;
      }
    },
    closeDialog() {
      if (this.$route.name === 'Cookies') {
        setTimeout(() => {
          util.jumpToTop()
        }, 140);
      }
      this.isDialog = false;
      // this.$emit('close');//no
    },
    clickOk() {
      // this.$emit('yes');

      //save dsgvo
      let dsgvo = {
        statistics: this.statistics,
        preferences: this.preferences,
        // facebook: this.facebook,
      };
      let exp = 24 * 60 * 60 * 1000; //1 day
      if (this.statistics) {
        exp = 12 * 30 * 24 * 60 * 60 * 1000//expiry 12 Months
      }
      this.$ls.set('dsgvo', dsgvo, exp); //expiry 2 Months

      ebus.$emit('finishDsgvo');
      // this.$router.push({name: 'Home'});

      this.closeDialog();
    }
  }
}
</script>

<style lang="scss" scoped>
/*@import '../styles/vuetify-dark';*/


.dsgvo {
  color: black;

  * {
    color: black;
  }
}

.dsgvo ::v-deep {
  .v-input--selection-controls {
    padding-top: 0;
    margin-top: 0;
  }
}

</style>
